import React from 'react';
import CTALink from '../../buttons/CTALink';
import { useTranslation } from 'react-i18next';

export const ManageBooking = ({ to }: { to: string }) => {
	const { t } = useTranslation();
	return <CTALink to={to} text={t('actions.manage_booking')} variant='dark' />;
};
